import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonTableComponent, TableColumn } from 'src/app/components/common/common-table/common-table.component';
import { ContractorsJanusComponent } from '../contractors-janus.component';
import { ContractorsJanusActionComponent } from '../contractors-janus-table/cells-janus/contractors-janus-action-cell/contractors-janus-action.component';
import { StaffContractorRegistrationDetailsComponent } from '../contractor-registration-details/contractor-registration-details.component';
import { ContractorsJanusApplicationComponent } from '../contractors-janus-table/contractors-janus-application/contractors-janus-application.component';
import { ContractorsJanusRenewComponent } from '../contractors-janus-table/contractors-janus-renew/contractors-janus-renew.component';
import { ContractorsJanusProfileViewComponent } from './contractors-janus-profile-view/contractors-janus-profile-view.component';
import { Router, ActivatedRoute } from '@angular/router';
import { WorkflowContextService } from 'src/app/services';
import { CommonConfirmationModalData } from 'src/app/components/common/common-confirmation-modal/common-confirmation-modal.component.model';

type InlineRegistrationView =
  | 'details'
  | 'application'
  | 'renew'
  | 'profile';

const REGISTRATION_STATUS_CONFIG = {
  disableAllowed: ['approved', 'denied', 'inactive'],
  enableAllowed: ['disabled'],
  deleteBlocked: ['deleted'],
  renewBlocked: ['pending', 'deleted']
};

@Component({
  selector: 'app-all-contractors',
  standalone: false,
  templateUrl: './all-contractors.component.html',
  styleUrls: ['./all-contractors.component.scss']
})
export class AllContractorsComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @ViewChild('registrationTable')
  table!: CommonTableComponent;

  columns: TableColumn[] = [];
  columnLimitModalData: CommonConfirmationModalData = {
    open: false,
    modalDescp: 'Column Limit Reached',
    modalSubDescp: 'You can only show 7 columns at once.',
    okBtn: true,
    closeBtn: false,
    yesNoBtn: false,
    status: 'info'
  };

  expandedComponent: any = null;
  expandedComponentInputs: any = null;
  // Start Code added by Sanchit on 07/23/2026
  private pendingInlineRouteView:
  | 'details'
  | 'application'
  | 'renew'
  | 'profile'
  | null = null;

  private pendingInlineRouteId: string | null = null;
  private pendingPageNumber: number | null = null;
  // End Code added by Sanchit on 07/23/2026
  private applicationViewSubscription?: Subscription;
  private wasApplicationOverlayOpen = false;
  private requirementColumnsSubscription?: Subscription;
  constructor(public parent: ContractorsJanusComponent,
    private router: Router, // Code added by Sanchit on 07/23/2026
    private route: ActivatedRoute, // Code added by Sanchit on 07/23/2026
    public context: WorkflowContextService
  ) {
    this.buildColumns();
  }

  // Start Code added by Sanchit on 07/23/2026
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const page = params.get('page');

      this.pendingPageNumber = page
        ? Number(page)
        : null;

      const id = params.get('id');
      const registrationId = params.get('registrationId');

      const view = params.get('view') as
        | 'details'
        | 'application'
        | 'renew'
        | 'profile'
        | null;

      if (!id && !view) {
        this.clearInlineState();
      }

      this.pendingInlineRouteId =
        registrationId || id;

      this.pendingInlineRouteView = view;

      this.tryRestoreInlineRouteView();
    });
    // End Code added by Sanchit on 07/23/2026
    this.requirementColumnsSubscription =
      this.parent.registrationRequirementColumns$.subscribe(columns => {
        this.buildColumns(columns);
      });

    this.applicationViewSubscription =
      this.context.applicationViewType$.subscribe(viewType => {
        if (viewType === 'overlay') {
          this.wasApplicationOverlayOpen = true;
        } else if (viewType === 'none' && this.wasApplicationOverlayOpen && !this.pendingInlineRouteView && this.route.firstChild) {
          this.wasApplicationOverlayOpen = false;
          this.closeInline();
        }
      });
  }
  // Start Code added by Sanchit on 07/23/2026
  ngOnChanges(changes: SimpleChanges): void {
    this.tryRestoreInlineRouteView();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.tryRestoreInlineRouteView();
    }, 3000);
    // this.tryRestoreInlineRouteView();
  }

  private tryRestoreInlineRouteView(): void {

    if (
      this.pendingPageNumber &&
      this.parent.currentPage !== this.pendingPageNumber
    ) {
      this.parent.currentPage = this.pendingPageNumber;

      // Same method used in Renewals to load data
      this.parent.onRegistrationPageChange(
        this.pendingPageNumber
      );

      return;
    }
    if (
      this.expandedComponent ||
      !this.table ||
      !this.pendingInlineRouteId ||
      !this.pendingInlineRouteView
    ) {
      return;
    }

    const row = (this.parent.registrations || []).find(
      (r: any) => r.id === this.pendingInlineRouteId
    );

    if (!row) {
      return;
    }

    this.openInline(
      this.pendingInlineRouteView,
      row
    );
  }

  private getCurrentRoutePage(): number {
    return 1;
  }

  private clearInlineState(): void {
    this.expandedComponent = null;
    this.expandedComponentInputs = null;

    if (this.table) {
      this.table.expandedRow = null;
    }
  }

  private closeInlineRoute(): void {
    this.clearInlineState();

    this.router.navigate(['../all'], {
      relativeTo: this.route,
      queryParams: {
        id: null,
        registrationId: null,
        view: null,
        showAppView: null,
        workflowId: null,
        workflowVersionId: null,
        isTest: null,
        skipActivityNavigation: null,
        activityDataId: null,
        cid: null,
        isChild: null,
        isLinkedApp: null
      },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
  // End Code added by Sanchit on 07/23/2026



  ngOnDestroy(): void {
    this.applicationViewSubscription?.unsubscribe();
    this.requirementColumnsSubscription?.unsubscribe();
  }

  private buildColumns(requirementColumns: TableColumn[] = []): void {
    // Added by Amisha on 2026-07-17.
    // Reason: contractor registrations need their own renewals-style column widths and actions
    // while continuing to leave the contractor types table behavior untouched.
    this.columns = [
      { key: 'contractorName', label: 'Name', width: '200px', headerType: 'text', cellType: 'text', showExportOption: true } as any,
      { key: 'contractor', label: 'Business Name', width: '190px', headerType: 'text', cellType: 'text', showExportOption: true } as any,
      { key: 'type', label: 'Contractor Type', width: '210px', headerType: 'text', cellType: 'text', showExportOption: true } as any,
      { key: 'registeredOn', label: 'Registration Date', width: '190px', headerType: 'text', cellType: 'text', showExportOption: true } as any,
      { key: 'expiresOn', label: 'Expiration Date', width: '170px', headerType: 'text', cellType: 'text', showExportOption: true } as any,
      { key: 'status', label: 'Status', width: '110px', headerType: 'text', cellType: 'text', showExportOption: true } as any,
      ...requirementColumns,
      {
        key: 'action',
        label: 'Actions',
        width: '100px',
        headerType: 'text',
        cellType: 'component',
        showExportOption: false,
        component: ContractorsJanusActionComponent,

        componentInputs: (row: any) => ({
          row,

          // Start Code added by Sanchit on 07/23/2026
          // viewDetails: (item: any) =>
          //   this.openInline('details', item),
          viewDetails: (item: any) => {
            this.openInline('details', item);

            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                view: 'details',
                id: item.id,
                registrationId: item.id,
                page: this.parent.currentPage
              },
              queryParamsHandling: 'merge'
            });
          },

          // viewApplication: (item: any) =>
          //   this.openInline('application', item),

          viewApplication: (item: any) => {
            this.wasApplicationOverlayOpen = false;
            this.context.applicationViewType$.emit('none');
            this.openInline('application', item);

            this.router.navigate(['../all'], {
              relativeTo: this.route,
              queryParams: {
                view: 'application',
                id: item.createdApplicationId,
                registrationId: item.id,
                page: this.parent.currentPage
              },
              queryParamsHandling: 'merge'
            });
          },

          // renew: (item: any) =>
          //   this.openInline('renew', item),


          renew: (item: any) => {
            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                view: 'renew',
                id: item.id,
                registrationId: item.id,
                page: this.parent.currentPage
              },
              queryParamsHandling: 'merge'
            }).then(() => {
              this.openInline('renew', item);
            });
          },

          // viewProfile: (item: any) =>
          //   this.openInline('profile', item),

          viewProfile: (item: any) => {
            this.openInline('profile', item);

            this.router.navigate([], {
              relativeTo: this.route,
              queryParams: {
                view: 'profile',
                id: item.id,
                registrationId: item.id,
                page: this.parent.currentPage
              },
              queryParamsHandling: 'merge'
            });
          },
          // End Code added by Sanchit on 07/23/2026

          delete: (item: any) =>
            this.parent.openActionModal(
              item,
              'delete'
            ),

          disable: (item: any) =>
            this.parent.openActionModal(
              item,
              'disable'
            ),

          enable: (item: any) =>
            this.parent.openActionModal(
              item,
              'enable'
            ),

          canRenew: (item: any) =>
            this.canRenew(item),

          canDelete: (item: any) =>
            this.canDelete(item),

          canDisable: (item: any) =>
            this.canDisable(item),

          canEnable: (item: any) =>
            this.canEnable(item)
        })
      } as any
    ];
  }

  // Start Code added by Sanchit on 07/23/2026
  private clearInlineComponent(): void {
    this.expandedComponent = null;
    this.expandedComponentInputs = null;

    if (
      this.table &&
      typeof this.table.closeExpansion === 'function'
    ) {
      this.table.closeExpansion();
      return;
    }

    if (this.table) {
      this.table.expandedRow = null;
    }
  }
  // End Code added by Sanchit on 07/23/2026

  openInline(
    type: InlineRegistrationView,
    row: any
  ): void {
    if (!this.table || !row) {
      return;
    }

    this.clearInlineComponent(); // Code edited by Sanchit on 07/23/2026

    setTimeout(() => {
      switch (type) {
        case 'details':
          this.expandedComponent =
            StaffContractorRegistrationDetailsComponent;
          break;

        case 'application':
          if (!row.createdApplicationId) {
            this.parent.showWarning(
              'Application is not available for this registration.'
            );
            return;
          }

          this.expandedComponent =
            ContractorsJanusApplicationComponent;
          break;

        case 'renew':
          this.expandedComponent =
            ContractorsJanusRenewComponent;
          break;

        case 'profile':
          this.expandedComponent =
            ContractorsJanusProfileViewComponent;
          break;

        default:
          return;
      }

      this.expandedComponentInputs = (
        tableRow: any
      ) => {

        const commonInputs = {
          row: tableRow,
          registrationId: tableRow.id,
          closeExpansion: () =>
            this.closeInlineRoute() // Code edited by Sanchit on 07/23/2026
        };

        switch (type) {
          case 'details':
            return {
              ...commonInputs
            };

          case 'application':
            return {
              ...commonInputs,
              applicationId:
                tableRow.createdApplicationId
            };

          case 'renew':
            return {
              ...commonInputs,
              contractorId:
                tableRow.contractorId,
              contractorTypeId:
                tableRow.contractorTypeId
            };

          case 'profile':
            return {
              ...commonInputs,
              contractorId:
                tableRow.contractorId
            };

          default:
            return commonInputs;
        }
      };

      this.table.expandRow(row);
      // Start Code added by Sanchit on 07/23/2026
      setTimeout(() => {
      }, 500);
      // End Code added by Sanchit on 07/23/2026
    }, 0);
  }

  closeInline(): void {
    // Start Code added by Sanchit on 07/23/2026
    this.closeInlineRoute();
    // this.expandedComponent = null;
    // this.expandedComponentInputs = null;

    // if (
    //   this.table &&
    //   typeof this.table.closeExpansion === 'function'
    // ) {
    //   this.table.closeExpansion();
    //   return;
    // }

    // if (this.table) {
    //   this.table.expandedRow = null;
    // }
    // End Code added by Sanchit on 07/23/2026
  }

  onVisibleColumnLimitReached(message: string): void {
    this.columnLimitModalData = {
      ...this.columnLimitModalData,
      open: true,
      modalSubDescp: message
    };
  }

  private canRenew(item: any): boolean {
    return !REGISTRATION_STATUS_CONFIG.renewBlocked.includes(
      this.getNormalizedStatus(item)
    );
  }

  private canDelete(item: any): boolean {
    return !REGISTRATION_STATUS_CONFIG.deleteBlocked.includes(
      this.getNormalizedStatus(item)
    );
  }

  private canDisable(item: any): boolean {
    return REGISTRATION_STATUS_CONFIG.disableAllowed.includes(
      this.getNormalizedStatus(item)
    );
  }

  private canEnable(item: any): boolean {
    return REGISTRATION_STATUS_CONFIG.enableAllowed.includes(
      this.getNormalizedStatus(item)
    );
  }

  private getNormalizedStatus(item: any): string {
    return String(item?.status || '')
      .trim()
      .toLowerCase();
  }
}
